import React, { useMemo } from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from './ui/sheet';
import { Button } from './ui/button';
import { MessageCircle, Tag } from 'lucide-react';

function brl(n) { return `R$ ${Number(n || 0).toFixed(2).replace('.', ',')}`; }

export default function MenuSheet({ open, onClose, biosite, onProductClick }) {
  const theme = useMemo(() => biosite || {}, [biosite]);
  const whats = (biosite?.whatsappForOrders || '').replace(/\D/g, '');

  const makeWhatsUrl = (p) => {
    const base = whats ? `https://wa.me/${whats}` : 'https://wa.me/';
    const price = p.salePrice > 0 ? p.salePrice : p.price;
    const msg = `Olá! Quero pedir: *${p.name}* — ${brl(price)}`;
    return `${base}?text=${encodeURIComponent(msg)}`;
  };

  return (
    <Sheet open={open} onOpenChange={(o) => !o && onClose()}>
      <SheetContent side="bottom" className="max-h-[90vh] overflow-y-auto bg-white p-0">
        <div className="max-w-xl mx-auto">
          <SheetHeader className="px-5 pt-5 pb-3 border-b border-neutral-200 sticky top-0 bg-white z-10">
            <SheetTitle className="font-display text-xl">Cardápio</SheetTitle>
            <p className="text-xs text-neutral-500">Faça seu pedido direto pelo WhatsApp</p>
          </SheetHeader>

          <div className="px-5 py-5 space-y-7">
            {(biosite?.menu || []).length === 0 && (
              <div className="text-center text-neutral-500 py-10">Cardápio em breve.</div>
            )}
            {(biosite?.menu || []).map((cat) => {
              const items = (cat.products || []).filter((p) => p.enabled !== false);
              if (items.length === 0) return null;
              return (
                <section key={cat.id}>
                  <h3 className="text-sm font-bold uppercase tracking-wider text-neutral-500 mb-3">{cat.name}</h3>
                  <div className="space-y-3">
                    {items.map((p) => {
                      const hasPromo = p.salePrice > 0 && p.salePrice < p.price;
                      return (
                        <div key={p.id} className="flex gap-3 bg-neutral-50 rounded-2xl p-3 border border-neutral-200">
                          <div className="w-24 h-24 rounded-xl bg-neutral-200 overflow-hidden flex-shrink-0">
                            {p.image ? (
                              <img src={p.image} alt={p.name} className="w-full h-full object-cover" />
                            ) : <div className="w-full h-full grid place-items-center text-neutral-400"><Tag size={20} /></div>}
                          </div>
                          <div className="flex-1 min-w-0">
                            <div className="font-bold text-neutral-900 truncate">{p.name}</div>
                            {p.description && <div className="text-xs text-neutral-600 mt-0.5 line-clamp-2">{p.description}</div>}
                            <div className="mt-1.5 flex items-baseline gap-2">
                              <div className="text-base font-bold text-neutral-900">{brl(hasPromo ? p.salePrice : p.price)}</div>
                              {hasPromo && (
                                <div className="text-xs text-neutral-400 line-through">{brl(p.price)}</div>
                              )}
                            </div>
                            <a
                              href={makeWhatsUrl(p)}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={() => onProductClick && onProductClick(p)}
                              className="inline-flex items-center gap-1.5 mt-2 text-xs font-semibold text-white bg-emerald-600 hover:bg-emerald-700 rounded-full px-3 py-1.5 transition"
                            >
                              <MessageCircle size={12} /> Pedir pelo WhatsApp
                            </a>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </section>
              );
            })}
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
